module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img35.909dd922.jpg";